import { SET_SHOW_TUTORIAL } from '../actions/types';

const initialState = {
  showTutorial: false
};

const tutorialReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_TUTORIAL:
      return {
        ...state,
        showTutorial: action.payload
      };
    default:
      return state;
  }
};

export default tutorialReducer; 